<script setup lang="ts">
const DISCOUNT_LABEL_TYPES = [2, 4, 5];
interface ICatalogHeaderLabelProps {
  text: string;
  labelType: number;
}

const props = defineProps<ICatalogHeaderLabelProps>();

const prefix = computed<"от" | "до" | null>(() =>
  props.labelType === 4 ? "от" : props.labelType === 5 ? "до" : null,
);
</script>

<template>
  <div
    v-if="labelType !== 1"
    class="catalog-header-label"
    :class="{
      'catalog-header-label_sale': DISCOUNT_LABEL_TYPES.includes(labelType),
    }"
  >
    <span class="catalog-header-label__text">
      <span v-if="prefix" class="catalog-header-label__text-prefix">{{
        prefix
      }}</span>
      {{ text }}
    </span>
  </div>
</template>

<style lang="postcss">
.catalog-header-label {
  font-family: var(--font-family-secondary);
  color: var(--pl-text-invert-primary);
  background: #a30051;
  width: 72px;
  height: 36px;
  font-size: 24px;
  line-height: 34px;
  text-align: center;
  border-radius: 16px 24px 0 16px;

  &_sale {
    background: #d01481;
  }

  &__text {
    position: relative;
    display: inline-block;
    word-spacing: -4px;

    &-prefix {
      font-size: 11px;
      line-height: 12px;
      position: absolute;
      top: 3px;
      left: 0;
    }
  }
}

@media (--pl-viewport-from-l) {
  .catalog-header-label {
    width: 104px;
    height: 52px;
    font-size: 36px;
    line-height: 48px;
    border-radius: 24px 32px 0 24px;

    &__text {
      word-spacing: -8px;

      &-prefix {
        font-size: 12px;
        line-height: 14px;
        top: 8px;
        left: 0;
      }
    }
  }
}
</style>
